import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    title: 'heading-2xl-desk max-sm:heading-2xl',
    header: 'mb-3 max-sm:flex max-sm:justify-between max-sm:gap-3',
    mobileCloseButton: '-mt-2 hidden size-10 p-0 max-sm:block',
    closeIcon: 'size-8',
    form: '',
    closeButton: 'max-sm:hidden',
    content: 'py-6'
  }
});
